/* Reload the page when resizing - Some elements get the heights from JS */

let initialWidth = window.innerWidth;
/*
window.addEventListener('resize', function (event) {
  if (window.innerWidth > initialWidth + 150 || window.innerWidth < initialWidth - 150) {
    initialWidth = window.innerWidth;
    window.location.reload();
  }
});
*/


/* Header */

const slideshow = document.querySelector(".index-section--slideshow");
const imageHeader = document.querySelector(".custom_page_header_section");

if ((slideshow || imageHeader) && initialWidth >= 750) {
	const searchBar = document.querySelector(".search-bar__interior");
	const input = document.getElementById("predictive-search-drawer-input");

	searchBar.classList.add("transparent");

	input.addEventListener("focus", () => {
		searchBar.classList.remove("transparent");
	});
	input.addEventListener("focusout", () => {
		searchBar.classList.add("transparent");
	});
}

/* Mega Menu - Swatches Tooltip */

document.querySelectorAll(".camo-swatch").forEach((el) => {
	el.addEventListener("mouseenter", (evt) => {
		evt.target.querySelector(".filter-tooltip").classList.add("visible");
	});
	el.addEventListener("mouseleave", (evt) => {
		evt.target.querySelector(".filter-tooltip").classList.remove("visible");
	});
});

/* Mega Menu - Main Navigation */

document
	.querySelectorAll(
		".nav-bar__item.item-has-mega-menu:not(.categories_menu .nav-bar__item.item-has-mega-menu)",
	)
	.forEach((el) => {
		el.addEventListener("mouseenter", (evt) => {
			evt.target.classList.add("active");
		});
		el.addEventListener("mouseleave", (evt) => {
			evt.target.classList.remove("active");
		});
	});

/* Product card item */

if (document.body.classList.contains("template-collection")) {
	document.querySelectorAll(".grid__item").forEach((el) => {
		el.addEventListener("mouseenter", (evt) => {
			evt.target
				.querySelector(".product-item__action-list__wrapper")
				?.classList.add("active");
			evt.target.classList.add("active");
		});
		el.addEventListener("mouseleave", (evt) => {
			evt.target
				.querySelector(".product-item__action-list__wrapper")
				?.classList.remove("active");
			evt.target.classList.remove("active");
		});
	});
}

/* Product template */

if (document.body.classList.contains("template-product")) {
	const mainSlider = document.querySelector(".product-single__media__carousel");
	const thumbSlider = document.querySelector(".product-single__thumbnails");
	const colorSwatches = document.querySelectorAll(".swatch-element.color");

	if (colorSwatches && thumbSlider) {
		for (let colorSwatch of colorSwatches) {
			colorSwatch.addEventListener("click", () => {
				setTimeout(() => {
					//Get the current variant ID
					let urlParams = new URLSearchParams(window.location.search);
					let currentVariant = urlParams.get("variant");

					// Get carousel instance
					let thumbFlkty = Flickity.data(thumbSlider);
					let mainCarousel = Flickity.data(mainSlider);

					let slideElements = Array.from(thumbFlkty.getCellElements());

					// Filter slides
					slideElements.forEach(function (slideElement) {
						slideElement.classList.add("hide");

						let variants = slideElement.dataset.variants.split(",");
						if (variants.includes(currentVariant) || variants[0] == "") {
							slideElement.classList.remove("hide");
						}
					});

					// Get featured image
					const featured = slideElements.filter(function (slideElement) {
						let variants = slideElement.dataset.variants.split(",");
						return variants.includes(currentVariant);
					});

					// Reload Flickity to update the carousel with the filtered slides
					thumbFlkty.reloadCells();

					//Check the media index for the selected element and change the main carousel
					let selectedElement = featured[0];

					let mediaIndex = selectedElement?.dataset?.thumbIndex || null;

					let mainSliderElements = Array.from(mainCarousel.getCellElements());

					if (mediaIndex) {
						let cell = mainSliderElements.findIndex((el) => {
							return el.dataset.mediaIndex == mediaIndex;
						});
						mainCarousel.selectCell(cell);
					}

					// Resize Flickity to ensure proper layout
					thumbFlkty.resize();
				}, 200);
			});
		}
		document.querySelector("input[checked]")?.parentElement?.click();
	}

	// Size Chart

	const sizeChart = document.getElementById("size-popup");
	const sizeChartBtn = document.getElementById("size-chart-btn");
	const sizeChartCloseBtn = document.querySelector(".size-popup-close");

	if (sizeChart && sizeChartBtn) {
		sizeChartBtn.addEventListener("click", () => {
			sizeChart.classList.add("active");
			document.body.classList.add("no-scroll");
		});
		sizeChartCloseBtn.addEventListener("click", () => {
			sizeChart.classList.remove("active");
			document.body.classList.remove("no-scroll");
		});
		sizeChart.addEventListener("click", () => {
			sizeChart.classList.remove("active");
			document.body.classList.remove("no-scroll");
		});
	}
}

/* Collection template */

if (document.body.classList.contains("template-collection")) {
	/* Camo Search */

	const camoSearchInput = document.getElementById("camo-search");
	const camoList = camoSearchInput?.parentElement.nextElementSibling;
	const camoListElements = camoList?.querySelectorAll('li[data-group="camo"]');

	camoSearchInput?.addEventListener("input", (e) => {
		let searchTerm = e.target.value.toLowerCase();

		if (!camoListElements) return;

		const visibleElements = [];

		for (let element of camoListElements) {
			if (searchTerm && !element.innerHTML.toLowerCase().includes(searchTerm)) {
				element.style.display = "none";
				element.setAttribute("aria-hidden", "true");
			} else {
				element.style.display = "list-item";
				element.setAttribute("aria-hidden", "false");
				visibleElements.push(element);
			}
		}
	});

	/* Filter Swatch Tooltip */

	document.querySelectorAll("li.advanced-filter").forEach((el) => {
		if (el.querySelector(".filter-swatch")) {
			el.addEventListener("mouseenter", (evt) => {
				evt.target.querySelector(".filter-tooltip")?.classList.add("visible");
			});
			el.addEventListener("mouseleave", (evt) => {
				evt.target.querySelector(".filter-tooltip")?.classList.remove("visible");
			});
		}
	});
}
